import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ValidateDocumentService } from '@shared/services/validate-document/validate-document.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FieldTypeTextSimpleComponent } from '../field-type-text/field-type-text-simple/field-type-text-simple.component';
import { FormsModule } from '@angular/forms';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { find } from 'lodash';

@Component({
    selector: 'rename-modal',
    templateUrl: './rename-modal.component.html',
    standalone: true,
    imports: [FormsModule, FieldTypeTextSimpleComponent, AfTranslateDirective]
})
export class RenameModalComponent implements OnInit {
  skin: string = this.globalCfg.skin;
  custom:any = this.customLanding.getCustom();
  isLanding:boolean = this.customLanding.isLanding();
  evaluationId:any = this.route.snapshot.params['evaluationId'] || this.route.snapshot.firstChild?.params['evaluationId'];
  limitExceeded: boolean = false;
  configuration: any = this.dialogConfig.data;
  list: any = this.dialogConfig.data.list;
  otherList: any = this.dialogConfig.data.otherList;
  renameModal:any ={
    infoDescription: '',
    showInfoText: false,
    whistleProduct: this.skin === 'steel-blue' && this.context.settings.defaultProduct === 'whistle',
    acceptButton: this.translate.instant('common.ok'),
    // name: '',
    nameInfo: {
      fieldId: 'name-info',
      required:  true,
      description: null,
      addEnter:true
    },
    suffixInfo: {
      fieldId: 'suffix-info',
      noEditable: true,
      label: this.translate.instant('rename-modal.suffix-label')
    },
    nameList: [],
    title: '',
    extension:'',
    suffix:'',
  }
  constructor(private globalCfg: GlobalCfgFactory,
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private route: ActivatedRoute,
    private validateDocumentService: ValidateDocumentService,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private customLanding: CustomLandingFactory,
    private context: ContextFactory,
    private dialogRef: DynamicDialogRef<RenameModalComponent>,
    private dialogConfig: DynamicDialogConfig) {}

  ngOnInit(): void {
    this.configureTypes();
    if(this.configuration.type !== 'document' && this.configuration.type !== 'upload' && this.configuration.type !== 'duplicate'){
      this.configureCalls();
    }
  }

  configureTypes(){
    let lastPoint: number = 0;
    switch(this.configuration.type){
      case 'public':
        this.renameModal.nameInfo.label = this.translate.instant('common.affair');
        if(this.configuration.subtype === 'saveComunicationChannel'){
          this.renameModal.infoDescription = this.translate.instant('rename-modal.info-save-comunication-channel');
        }else if(this.configuration.subtype === 'saveBeforeSubcontainer'){
          this.renameModal.infoDescription = this.translate.instant('rename-modal.info-add-subgroup');
          this.renameModal.acceptButton = this.translate.instant('common.continue');
        }else if(this.configuration.subtype === 'generateTemplateFromFieldPublic'){
          this.renameModal.infoDescription = this.translate.instant('rename-modal.info-add-document');
          this.renameModal.acceptButton = this.translate.instant('common.continue');
        }else{
          this.renameModal.infoDescription = this.translate.instant('rename-modal.info-add-concept-landing');
        }
        break;
      case 'concept':
        this.renameModal.nameInfo.label = this.configuration.labelField?this.configuration.labelField:this.translate.instant('rename-modal.title-new');
        this.renameModal.acceptButton = this.configuration.rename?this.translate.instant('common.rename'):this.translate.instant('common.save');
        if (this.skin === 'icam-red' && this.configuration.namedKey === 'Usuario') {
          this.renameModal.nameInfo.label = "Id Usuario";
          this.renameModal.name = 'C######';
        }
        break;
      case 'evaluation':
        this.renameModal.nameInfo.label = this.translate.instant('rename-modal.title-new');
        this.renameModal.acceptButton = this.translate.instant('common.save');
        break;
      case 'title':
        this.renameModal.nameInfo.label = this.translate.instant('rename-modal.new-title');
        break;
      case 'upload':
        this.renameModal.nameInfo.label= this.translate.instant('rename-modal.title-new');
        this.configuration.title = this.translate.instant('documentation-list.rename-document');
        this.renameModal.acceptButton = this.translate.instant('common.rename');
        lastPoint = this.configureExtension();
        this.renameModal.name = lastPoint !== -1?this.configuration.previousTitle.substring(0, lastPoint):this.configuration.previousTitle;
        break;
      case 'related-forms':
        this.renameModal.nameInfo.label = this.translate.instant('rename-modal.name-instance');
        this.configuration.title = this.translate.instant('rename-modal.new-form-related');
        this.renameModal.infoDescription = this.translate.instant('rename-modal.info-new-report');
        break;
      case 'report':
        if(this.configuration.from === 'generateReport'){
          this.renameModal.infoDescription = this.translate.instant('rename-modal.info-new-report').replace('{title}',  this.configuration.previousTitle);
        }
        this.renameModal.nameInfo.label = this.translate.instant('rename-modal.name-report');
        this.renameModal.acceptButton = this.configuration.rename?this.translate.instant('common.rename'):this.translate.instant('common.generate');
        break;
      case 'folder':
        this.renameModal.nameInfo.label = this.configuration.rename?this.translate.instant('rename-modal.new-name'):this.translate.instant('rename-modal.name-folder');
        this.renameModal.acceptButton = this.configuration.rename?this.translate.instant('common.rename'):this.translate.instant('common.save');
        break;
      case 'document':
        this.renameModal.nameInfo.label = this.translate.instant('rename-modal.title-new');
        this.renameModal.acceptButton = this.translate.instant('common.rename');
        this.configureExtension();
        break;
      case 'duplicate':
        this.renameModal.nameInfo.label = this.translate.instant('documentation-list.name-new-document');
        this.renameModal.acceptButton = this.translate.instant('common.duplicate');
        this.renameModal.name = this.configureNameDuplicateDocument();
        this.configureExtension();
        break;
      case 'associated-documentation':
        this.renameModal.nameInfo.label = this.translate.instant('rename-modal.title-new');
        this.renameModal.acceptButton = this.translate.instant('common.rename');
        lastPoint = this.configureExtension();
        this.renameModal.name = lastPoint !== -1?this.configuration.previousTitle.substring(0, lastPoint):this.configuration.previousTitle;
        this.configureExtension();
        break;
      default:
        this.renameModal.nameInfo.label = this.translate.instant('rename-modal.name-'+this.configuration.type);
        break;
    }
  }

  configureExtension(){
    let lastPoint = this.configuration.previousTitle.lastIndexOf('.');
    if(lastPoint !== -1){
      this.renameModal.extension = this.configuration.previousTitle.substring(lastPoint, this.configuration.previousTitle.length);
    }
    return lastPoint;
  }

  configureNameDuplicateDocument(){
    let name = this.configuration.previousTitle.substr(0, this.configuration.previousTitle.lastIndexOf('.'));
    let nameDuplicated : any = this.configuration.previousTitle.substr(0, this.configuration.previousTitle.lastIndexOf('.'));
    if (this.list?.length) {
      let nameIdx = 0;
      let existingFolder: any;
      do {
        if(nameIdx === 1){
          name = nameDuplicated + ' (' + this.translate.instant('duplicate-evaluation.copy').toLowerCase() + ')';
        }else if(nameIdx && nameIdx > 1){
          name = nameDuplicated + ' (' + this.translate.instant('duplicate-evaluation.copy').toLowerCase() + ' ' + nameIdx + ')';
        }
        existingFolder = find(this.list, (item:any, index: number)=> {
          let nameItem : any = item.name.substr(0, item.name.lastIndexOf('.'));
          return nameItem.toLowerCase() === name.toLowerCase();
        });
        nameIdx++;
      } while (existingFolder);
    }
    return name;
  }

  configureCalls(){
    if(this.configuration.conceptId && this.configuration.type !== 'public'){
      if(this.configuration.type === 'concept'){
        this.getListConcept();
      }else if(this.renameModal.whistleProduct){
        this.getListReportsWhistle();
      }else{
        this.getListReport();
      }
    }else if(!this.configuration.rename){
      this.renameModal.name = this.configuration.previousTitle;
    }
  }

  getListConcept(){
    this.apiService.get('conceptobjects/byconceptid', this.configuration.conceptId)
      .then((data:any)=>{
        this.renameModal.nameList = data;
        if(this.configuration.rename){
          if(this.configuration.previousTitle.indexOf('[') !== -1){
            this.renameModal.suffix = this.configuration.previousTitle.substring(this.configuration.previousTitle.indexOf('['), this.configuration.previousTitle.length);
            this.renameModal.name =  $.trim(this.configuration.previousTitle.substring(0, this.configuration.previousTitle.indexOf('[')))
          }
        }else if(this.skin !== 'icam-red' && this.configuration.namedKey !== 'Usuario'){
          this.renameModal.name = this.getNameNewConceptOrReport();
        }
      });
  }

  getListReportsWhistle(){
    this.apiService.get('be/wh/dashboard/reportobjects')
      .then((data:any)=>{
        this.renameModal.nameList = data;
        this.renameModal.name = !this.configuration.rename? this.getNameNewConceptOrReport() : this.configuration.previousTitle;
      });
  }

  getNameNewConceptOrReport(){
    var name = this.configuration.previousTitle;
    var nameConceptOrigin = this.configuration.previousTitle;
    if (this.renameModal.nameList && this.renameModal.nameList.length) {
      if(this.renameModal.nameList[0].parentconcepttitle && !this.renameModal.nameList[0].title){
        name = nameConceptOrigin+' (' + (this.renameModal.nameList.length+1) + ')';
      }else{
        var nameIdx = 0;
        do {
          if (nameIdx) {
            name = nameConceptOrigin+' (' + nameIdx + ')';
          }
          var existingFolder = this.renameModal.nameList.filter((item:any)=>item.title.toLowerCase() === name.toLowerCase())[0]
          nameIdx++;
        } while (existingFolder);
      }
    }
    return name;
  }

  getListReport(){
    let url:string = this.evaluationId?'reportobjects/byreportid/'+this.configuration.conceptId: 'reportobjects/byreportid';
    let id:any = this.evaluationId? this.evaluationId : this.configuration.conceptId;
    this.apiService.get(url, id)
      .then((data:any)=>{
        this.renameModal.nameList = data.reports;
        this.renameModal.name = this.configuration.rename?this.configuration.previousTitle:this.getNameNewConceptOrReport();
      });
  }

  itemSelected(e: any, item:string){
    this.renameModal[item] = e.newValue;
    if(e.addEnter){
      this.validateFields();
    }else if(this.limitExceeded){
      this.limitExceededCharacters();
    }
  }

  validateFields(){
    this.renameModal.nameInfo.error = false;
    this.renameModal.nameInfo.errorText = '';
    if(this.renameModal.name === '' || this.renameModal.name === undefined){
      this.renameModal.nameInfo.error = true;
      this.configureErrorModal();
    }else if(!this.limitExceededCharacters()){
      this.renameModal.nameInfo.error = false;
      if(this.configuration.conceptId && this.configuration.type !== 'public'){
        if(this.configuration.type === 'concept' && this.skin !== 'icam-red'){
          // this.configuration.previousTitle === this.renameModal.name? this.handleDismiss() : this.validateConceptName(this.renameModal.name);
          this.validateConceptName(this.renameModal.name);
        }else if(this.configuration.type === 'report'){
          this.validateReportName(this.renameModal.name);
        } else {
          this.handleAccept();
        }
      }else if(this.configuration.type ==='folder'){
        this.configuration.previousTitle === this.renameModal.name? this.handleDismiss() : this.validateFolderName(this.renameModal.name);
      }else if(this.configuration.type ==='document' || this.configuration.type === 'upload'){
        let name = this.renameModal.name + this.renameModal.extension;
        this.configuration.previousTitle === name? this.handleDismiss() : this.validateDocumentatinoName(name);
      }else if(this.configuration.type === 'duplicate'){
        this.validateDocumentatinoName(this.renameModal.name + this.renameModal.extension);
      }else if(this.configuration.type ==='related-forms'){
        var hasError = false;
        for(var i = 0; i < this.list.length; i++){
          if(this.renameModal.name === this.list[i].title){
            this.renameModal.nameInfo.error = true;
            this.renameModal.nameInfo.errorText = this.translate.instant('rename-modal.error-related-forms');
            hasError = true;
            break;
          }
        }
        if(!hasError){
          this.renameModal.nameInfo.error = false;
          this.handleAccept();
        }
      }else{
        this.handleAccept();
      }
    }
  }

  validateDocumentatinoName(name: any=''){
    if(this.validateDocumentService.correctCharacters(name)){
      if(this.validateDocumentService.duplicatedDocuments(name, this.list)){
        this.configureErrorModal();
        this.renameModal.nameInfo.errorText = this.translate.instant('export-modal.document-name-exist');
      }else if(this.configuration.type === 'upload' && this.validateDocumentService.duplicatedDocuments(name, this.otherList)){
        this.configureErrorModal();
        this.renameModal.nameInfo.errorText = this.translate.instant('documentation-list.duplicated-name-inner-list');
      }else{
        this.renameModal.nameInfo.error = false;
        this.handleAccept();
      }
    }else{
      this.configureErrorModal();
      this.renameModal.nameInfo.errorText = this.translate.instant('rename-modal.invalid-document');
    }
  }

  configureErrorModal(){
    switch(this.configuration.type){
      case 'public':
        this.modalService.errorModal({text: this.translate.instant('rename-modal.error-modal-case')});
        break;
      case 'folder':
        this.modalService.errorModal({text: this.translate.instant('rename-modal.error-modal-folder')});
        break;
      case 'concept':
        this.modalService.errorModal({text: this.translate.instant('rename-modal.error-modal-concept')});
        break;
      case 'report':
        this.modalService.errorModal({text: this.translate.instant('export-modal.error-validation')});
        break;
      case 'document':
      case 'upload':
        this.renameModal.nameInfo.error = true;
        this.modalService.errorModal({text: this.translate.instant('documentation-list.error-configuration-add-document')});
        break;
      case 'duplicate':
        this.renameModal.nameInfo.error = true;
        this.modalService.errorModal({text: this.translate.instant('duplicate-modal.error-check-name-modal')});
        break;
      default:
        break;
    }
  }

  limitExceededCharacters(){
    this.limitExceeded = false;
    let textLimit = '';
    switch(this.configuration.type){
      case 'concept':
      case 'public':
        this.limitExceeded = this.renameModal.name.length > 250;
        textLimit = this.translate.instant('rename-modal.exceeded-characters-concept');
        break;
      case 'document':
      case 'upload':
        this.limitExceeded = this.renameModal.name.length > 100;
        textLimit = this.translate.instant('rename-modal.exceeded-characters');
        break;
      default:
        break;
    }
    this.renameModal.nameInfo.error = this.limitExceeded;
    this.renameModal.nameInfo.errorText = textLimit;
    return this.limitExceeded;
  }

  validateConceptName(name:string){
    for(var i = 0; i < this.renameModal.nameList.length; i++){
      if(this.renameModal.nameList[i].title === name){
        if(this.renameModal.nameList[i].conceptObjectId !== parseInt(this.configuration.conceptObjectId)){
          this.renameModal.nameInfo.error = true;
          this.renameModal.nameInfo.errorText = this.configuration.type === 'report'?this.translate.instant('rename-modal.error-title-report'):this.translate.instant('rename-modal.error-title-instance');
          this.configureErrorModal();
          break;
        }else{
          this.handleDismiss();
          break;
        }
      }else{
        this.renameModal.nameInfo.error = false;
      }
    }
    if(!this.renameModal.nameInfo.error ){
      this.handleAccept();
    }
  }

  validateReportName(name:any){
    loop1:
    for(var i = 0; i < this.renameModal.nameList.length; i++){
      var reportObjects = this.renameModal.nameList[i];
      if(reportObjects.reportId === this.configuration.conceptId){
        if(reportObjects.title === name){
          if(reportObjects.reportObjectId !== parseInt(this.configuration.conceptObjectId )){
            this.renameModal.nameInfo.error = true;
            this.renameModal.nameInfo.errorText = this.translate.instant('rename-modal.error-title-report');
            this.configureErrorModal();
            break loop1;
          }else{
            this.handleDismiss();
            break;
          }
        }else{
          this.renameModal.nameInfo.error = false;
        }
      }
    }
    if (!this.renameModal.nameInfo.error && !this.commonUtilsService.validateNoSpecialCharacters(this.renameModal.name)) {
      this.renameModal.nameInfo.error = true;
      this.renameModal.nameInfo.errorText = this.translate.instant('rename-modal.incorrect-characters');
    }
    if(!this.renameModal.nameInfo.error){
      this.handleAccept();
    }
  }

  validateFolderName(name:any){
    for(var i = 0; i < this.list.length; i++){
      if(this.list[i].name === name){
        this.renameModal.nameInfo.error = true;
        this.renameModal.nameInfo.errorText = this.translate.instant('rename-modal.error-title-folder');
        this.configureErrorModal();
        break;
      }else{
        this.renameModal.nameInfo.error = false;
      }
    }
    if(!this.renameModal.nameInfo.error){
      this.handleAccept();
    }
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      name: this.renameModal.suffix ? this.renameModal.name + ' ' + this.renameModal.suffix: this.renameModal.name
    })
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
